<template>
    <div class="max-width-content">
        <trashed-message v-if="jobtemplate.deleted_at" class="mb-6">
            This jobtemplate has been deleted.
        </trashed-message>

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.jobtemplates.index')">Banen</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ jobtemplate.title | truncate(35) }}
            </breadcrumbs>

            <div v-if="!jobtemplate.deleted_at">
                <link-button :href="route('admin.jobtemplates.edit', jobtemplate.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.jobtemplates.destroy', jobtemplate.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <h1 class="text-5xl text-teal-800 mr-1 leading-tight mt-3">{{ jobtemplate.title }}</h1>

        <div class="bg-white px-3 py-1 rounded-lg">
            <tag-select
                    :tags="tags"
                    :tags-selected="jobtemplate.tags"
                    :loading="loading"
                    @tag-added="addTag"
                    @tag-removed="removeTag"
            ></tag-select>
        </div>

        <div class="mt-3 px-5 py-3 bg-white leading-loose grid grid-cols-4 rounded-lg">

            <div class="col-span-2">Salaris range:</div>
            <div class="col-span-2">{{ jobtemplate.salary_min }} - {{ jobtemplate.salary_max }}</div>

            <div class="col-span-2">Greenness label:</div>
            <div class="col-span-2">{{ jobtemplate.greenness_label }}</div>

            <div class="col-span-2">Negeer (want ongeschikt/niet groen):</div>
            <div class="col-span-2">{{ jobtemplate.ignore ? 'ja' : 'nee' }}</div>

        </div>



    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";
import TagSelect from "@/admin/Components/TagSelect";

export default {
    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, TrashedMessage, LinkButton, ConfirmButton, TagSelect },

    props: {
        jobtemplate: {
            Type: Object
        },
        tags: Array
    },
    data() {
        return {};
    },
    methods: {

        addTag(tag) {
            this.loading = "addTag";

            const url = this.route("admin.jobtemplates.tags.store", this.jobtemplate.id);
            const data = { tagId: tag.id };
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: () => { this.tag = "", this.loading = "" }
            }

            this.$inertia.post(url, data, options)
        },

        removeTag(tag) {
            this.loading = "removeTag"+tag.id;

            const url = this.route("admin.jobtemplates.tags.destroy", this.jobtemplate.id) + "?tagId=" + tag.id;
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: () => this.loading = false
            };

            this.$inertia.delete(url, options);
        },

    },

    metaInfo() {
        return { title: this.jobtemplate.title + " | Voorvertoning" };
    }
};
</script>
